import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class HttpLoadingService {
  loading$ = new BehaviorSubject<boolean>(false);
  private apiCount = 0;

  public setValue(newValue: boolean) {
    this.loading$.next(newValue);
  }

  public showLoadingIndicator() {
    if (this.apiCount === 0) {
      this.loading$.next(true);
    }
    this.apiCount++;
  }

  public hideLoadingIndicator() {
    this.apiCount = this.apiCount === 0 ? 0 : this.apiCount -1;
    if (this.apiCount === 0) {
      this.loading$.next(false);
    }
  }
}
